import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackEvent } from "./firebase";

/**
 * Logs a GA4 `page_view` event whenever the route changes.
 * Mount once inside <BrowserRouter>.
 */
export default function usePageViewTracking() {
  const location = useLocation();
  useEffect(() => {
    trackEvent("page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}

/**
 * Convenience tracker for outbound CTA clicks.
 * Use as onClick handler — does NOT prevent navigation.
 */
export function trackOutboundClick(id, href, extra = {}) {
  trackEvent("select_content", {
    content_type: "cta_outbound",
    item_id: id,
    link_url: href,
    ...extra,
  });
}
